/* unplugin-vue-components disabled */import script from "./Zxfw.vue?vue&type=script&lang=ts&setup=true"
export * from "./Zxfw.vue?vue&type=script&lang=ts&setup=true"

import "./Zxfw.vue?vue&type=style&index=0&id=26f69c31&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f69c31"]])

export default __exports__